import { useState } from "react";
import axios from "axios";

const GenerateDriverInvoice = ({ orderId, transactionId }) => {
  const [isBusy, setIsBusy] = useState(false);
  const token = localStorage.getItem("token");

  const createInvoice = async () => {
    axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT}driver-invoice`,
        {
          orderId: orderId,
          transactionId: transactionId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      )
      .then((res) => {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(blob);
        setIsBusy(false);
        window.open(fileURL);
      })
      .catch(console.error);
  };
  return (
    <button
      onClick={() => {
        setIsBusy(true);
        createInvoice();
      }}
      disabled={isBusy === true ? true : false}
      className="btn px-3 btn-outline btn-primary btn-color-white btn-sm"
      title="Print Invoice"
    >
      {isBusy === true ? (
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      ) : (
        <>
          <i className="bi-duotone bi-printer fs-5"></i>
          Print
        </>
      )}
    </button>
  );
};

export default GenerateDriverInvoice;
